import styled from "styled-components";

const breakPointStyle = `
width: 100%;
margin-top: 0;
`;
export const TitleH1 = styled.h1`
  color: var(--catalina-blue);
  font-size: 2rem;
  font-family: Poppins;
  font-weight: bold;
  word-break: break-word;
  margin: 0;
  @media (max-width: 1300px) {
    margin: 0;
  }
  @media (max-width: 1082px) {
    ${breakPointStyle}
  }
  @media (max-width: 760px) {
    ${breakPointStyle}
    font-size:1.5rem;
  }
  @media (max-width: 673px) {
    ${breakPointStyle}
    font-size:1.2rem;
  }
  @media (max-width: 370px) {
    ${breakPointStyle}
  }
  @media (max-width: 320px) {
    ${breakPointStyle}
  }
  margin-top: calc(120px - var(--headerHeight));
`;

export const Step1Img = styled.img`
  width: 486px;
  height: 324px;
  z-index: -1;
  display: flex;
  align-self: end;
  @media (max-width: 1082px) {
    left: 0;
    align-self: start;
  }
  @media (max-width: 760px) {
    top: 30vh;
  }
  @media (max-width: 673px) {
    ${breakPointStyle}
    font-size:1.2rem;
  }
  @media (max-width: 370px) {
    ${breakPointStyle}
  }
  @media (max-width: 320px) {
    ${breakPointStyle}
  }
`;

const stepWidth = "40rem";
const textImageHeight = "620px";
export const Box = styled.div`
  width: calc(100vw - ${stepWidth} - 16rem);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 59vh;
  min-height: 420px;
  @media (min-height: 1300px) {
    height: auto;
    min-height: 550px;
  }
  @media (max-width: 1300px) {
    width: calc(100vw - 28rem - 16rem);
  }
  @media (max-width: 1082px) {
    width: 100%;
  }
  @media (max-width: 698px) {
    height: ${textImageHeight};
    width: 100%;
  }
  @media (max-width: 573px) {
    height: ${textImageHeight};
    width: 100%;
  }
  @media (max-width: 370px) {
    height: ${textImageHeight};
    width: 100%;
  }
  @media (max-width: 320px) {
    height: ${textImageHeight};
    width: 100%;
  }
`;

export const TextSection = styled.div`
  background-color: var(--pink);
  postion: relative;
`;

export const Text = styled.p`
  font-size: 1.3rem;
  font-family: Poppins;
  font-weight: bold;
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 30px;
  margin-top: 1.6rem;
`;

export const StyledSvg = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
`;

export const StyledTextZone = styled.div`
  height: 225px;
`;
